import {startOfMonth} from "date-fns";
import {inZone} from "./in-zone";

/**
 * @hidden
 */
export function startOfMonthInZone(date: Date, zone: string): Date;

/**
 * @hidden
 */
export function startOfMonthInZone(date: undefined, zone: string): undefined;

/**
 * @hidden
 */
export function startOfMonthInZone(date: null, zone: string): null;

/**
 * @hidden
 */
export function startOfMonthInZone(date: Date | undefined, zone: string): Date | undefined;

/**
 * @hidden
 */
export function startOfMonthInZone(date: Date | null, zone: string): Date | null;

export function startOfMonthInZone(date: Date | undefined | null, zone: string): Date | undefined | null;

export function startOfMonthInZone(date: Date | undefined | null, zone: string): Date | undefined | null {
  return inZone(zone, startOfMonth, date);
}
